import React, { forwardRef, useEffect, useRef } from "react";
import Cleave from "cleave.js";
import styles from "./styles.module.scss";
import useDomainStore from "../../../stores/domain";

// ToDo: Remove forwardRef when we upgrade to React 19.
export const TextInput = forwardRef(
  (
    {
      id,
      name,
      type = "text",
      label,
      placeholder,
      prefix,
      suffix,
      touched = false,
      errored = false,
      error = "",
      hasWarning = "",
      cleaveOptions,
      ...props
    },
    ref,
  ) => {
    const { isKurvDomain } = useDomainStore();
    const inputRef = useRef(null);
    const cleaveInstance = useRef(null);

    useEffect(() => {
      if (!cleaveOptions) {
        return;
      }

      cleaveInstance.current = new Cleave(inputRef.current, {
        ...cleaveOptions,
      });

      return () => {
        if (cleaveInstance.current) {
          cleaveInstance.current.destroy();
        }
      };
    }, []);

    const hasError = touched && errored && error;

    return (
      <div className={`${styles.formGroup} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <label
          className={styles.label}
          htmlFor={id}
          style={{ display: !label && "none" }}
        >
          {label}
        </label>
        <div className={styles.inputWrapper}>
          {prefix && <span className={styles.prefix}>{prefix}</span>}
          {suffix && <span className={styles.suffix}>{suffix}</span>}
          <input
            ref={ref || inputRef}
            className={`${styles.input} ${prefix && styles.prefixInput} ${suffix && styles.suffixInput} ${hasError && styles.errorInput}`}
            type={type}
            id={id}
            placeholder={placeholder || label}
            name={name}
            {...props}
          />
        </div>
        {hasError && (
          <span className={styles.error} role="alert">
            {error}
          </span>
        )}
        {hasWarning && (
          <span className={styles.warning} role="alert">
            {hasWarning}
          </span>
        )}
      </div>
    );
  },
);

TextInput.displayName = "TextInput";

export default TextInput;
